import { render } from "./DataUPTD.vue?vue&type=template&id=5be6536a"
import script from "./DataUPTD.vue?vue&type=script&lang=js"
export * from "./DataUPTD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__